/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PostClientSegmentIntegrations$Params {
  clientId: string;
  'Active-Tenant-Identifier': string;
}

export function postClientSegmentIntegrations(http: HttpClient, rootUrl: string, params: PostClientSegmentIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postClientSegmentIntegrations.PATH, 'post');
  if (params) {
    rb.path('clientId', params.clientId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postClientSegmentIntegrations.PATH = '/segment-integrations/integrations/clients/{clientId}';
